import { getActionableByCode } from './../../../../utilities/error-codes';
import { sendAncillaryEventToCustomerIO } from './../../../../utilities/customer-io-ancillary-events';

export default (actionType, errorInfo) => {
  const actionable = errorInfo?.actionable || 'NA';
  const code = errorInfo?.code || 'NA';
  const recategorizedActionable = getActionableByCode(code, actionable);
  let subFunnelName = '';
  
  if (typeof actionType === 'string') {
    subFunnelName = actionType;
  } else {
    if (actionType.START === 'RETRIEVE_PNR') {
      subFunnelName = 'PnrLookup';
    } else if (actionType.START === 'RETRIEVE_SHOPPING_CART') {
      subFunnelName = 'Ancillary';
    }
  }

  const url = window?.location?.pathname;
  const splitUrl = url.split('/');
  const storeFront = splitUrl[splitUrl.length - 2];
  const finalUrl = splitUrl[splitUrl.length - 1];

  const result = {
    'event': 'am_error',
    'funnel_name': 'MYB',
    'sub_funnel_name': subFunnelName || 'NA',
    'error_message': errorInfo?.message || errorInfo?.msg || 'NA',
    'error_type': errorInfo?.actionable === 'ABORT' || errorInfo?.actionable === 'USER_ABORT' ? 'Fatal' : 'Warning',
    'error_category': recategorizedActionable,
    'error_code': code,
    'error_desc': errorInfo?.extraInfo?.debugging_stuff_here || 'NA',
    'error_source': 'Web',
    'error_url': `/${storeFront}/${finalUrl}`,
    'statusCode': errorInfo?.status || 'NA',
  };

 
  let pnrData = window.currentPNR;
  let pnrCode = null;
  
  if (pnrData && (pnrData.pnrCode || pnrData.pnr)) {
    pnrCode = pnrData.pnrCode || pnrData.pnr;
  }
  
  if (!pnrCode) {
    try {
      const storedPNR = JSON.parse(localStorage.getItem('currentPNR') || '{}');
      pnrCode = storedPNR?.pnrCode || storedPNR?.pnr;
      if (pnrCode) pnrData = storedPNR;
    } catch (e) {
      // Silent catch
    }
  }
  
  if (!pnrCode) {
    const urlParams = new URLSearchParams(window.location.search);
    pnrCode = urlParams.get('pnr');
  }
  
  if (!pnrCode && window.__REDUX_STORE__) {
    try {
      const state = window.__REDUX_STORE__.getState();
      pnrCode = state?.pnr?.pnrCode || state?.booking?.pnrCode || state?.currentPNR?.pnrCode;
    } catch (e) {
      // Error
    }
  }

  let userEmail = 'error-tracking@aeromexico.com'; // Default fallback
  
  if (pnrData) {
    userEmail = pnrData.passengers?.[0]?.email || 
               pnrData.passengers?.[0]?.contactEmail ||
               pnrData.email ||
               pnrData.contactInformation?.email ||
               userEmail;
  }

  const pnrInfo = pnrCode ? {
    pnrCode,
    email: userEmail,
    firstName: pnrData?.passengers?.[0]?.firstName || 'Guest',
    lastName: pnrData?.passengers?.[0]?.lastName || 'User',
  } : {
    pnrCode: 'UNKNOWN',
    email: userEmail,
    firstName: 'Guest',
    lastName: 'User',
  };

  try {
    sendAncillaryEventToCustomerIO('Ancillary_error', {
      event: 'am_error',
      errorMessage: result.error_message,
      errorType: result.error_type,
      errorCode: result.error_code,
      errorCategory: result.error_category,
      subFunnel: result.sub_funnel_name,
      pnrCode: pnrInfo.pnrCode,
      email: pnrInfo.email,
      timestamp: new Date().toISOString(),
      url: window.location.href,
    }, pnrInfo);
  } catch (customerIOError) {
    // error
  }

  return result;
};
